import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Gift, Layers, Link } from 'lucide-react';
import theme from '../theme';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CreatorUtilitiesPageWorking = () => {
  const navigate = useNavigate();
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(`${API}/creator/utilities`);
        setGroups(res.data || []);
      } catch (err) {
        console.error('Failed to load utilities:', err);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, []);

  if (loading) return <div style={{ padding: '40px', color: theme.colors.text.muted }}>Loading utilities...</div>;

  const hasAny = groups.some(g => g.utilities.length > 0);

  return (
    <div data-testid="creator-utilities-page" style={{ padding: '40px', maxWidth: '900px' }}>
      <h1 style={{ fontSize: '28px', fontWeight: 700, color: theme.colors.text.primary, marginBottom: '8px' }}>Utilities</h1>
      <p style={{ color: theme.colors.text.secondary, fontSize: '15px', marginBottom: '32px' }}>Utilities attached to your portfolios</p>

      {groups.length === 0 ? (
        <div style={{ background: theme.colors.bg.card, border: `1px solid ${theme.colors.borders}`, borderRadius: theme.radius.card, padding: '60px', textAlign: 'center' }}>
          <Layers size={40} style={{ color: theme.colors.text.muted, marginBottom: '12px' }} />
          <p style={{ color: theme.colors.text.muted, fontSize: '15px' }}>No portfolios found. Create a portfolio first.</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {groups.map(g => (
            <div key={g.portfolio_id} data-testid={`utility-group-${g.portfolio_id}`}
              style={{ background: theme.colors.bg.card, borderRadius: theme.radius.card, padding: '24px', border: `1px solid ${theme.colors.borders}` }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
                <Layers size={18} color={theme.colors.primary} />
                <h3 style={{ color: theme.colors.text.primary, fontSize: '16px', fontWeight: 600 }}>{g.portfolio_name}</h3>
                <span style={{ color: theme.colors.text.muted, fontSize: '13px' }}>({g.utilities.length} utilities)</span>
              </div>

              {g.utilities.length === 0 ? (
                <p style={{ color: theme.colors.text.muted, fontSize: '14px', padding: '12px 0' }}>No utilities attached to this portfolio</p>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {g.utilities.map((u, i) => (
                    <div key={u.id || i} data-testid={`utility-item-${u.id}`}
                      onClick={() => u.id ? navigate(`/creator/utilities/${u.id}`) : null}
                      style={{
                      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                      padding: '14px', background: theme.colors.bg.primary, borderRadius: theme.radius.sm,
                      border: `1px solid ${theme.colors.borders}`, cursor: 'pointer', transition: 'box-shadow 0.2s',
                    }}
                    onMouseEnter={e => e.currentTarget.style.boxShadow = theme.colors.shadows.sm}
                    onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Gift size={16} color={theme.colors.accent.teal} />
                        <div>
                          <p style={{ color: theme.colors.text.primary, fontSize: '14px', fontWeight: 600 }}>{u.title}</p>
                          <p style={{ color: theme.colors.text.muted, fontSize: '12px' }}>
                            {u.type} {u.provider_name ? `| by ${u.provider_name}` : ''}
                          </p>
                        </div>
                      </div>
                      <span style={{
                        padding: '4px 12px', borderRadius: '12px', fontSize: '12px', fontWeight: 600,
                        background: `${theme.colors.accent.teal}15`, color: theme.colors.accent.teal,
                      }}>
                        {typeof u.pricing === 'object' ? 'Custom' : u.pricing || 'Free'}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CreatorUtilitiesPageWorking;
